<template>
  <div class="navBar flex">
    <div class="cube flex" v-for="(item, index) in listBat" :key="index">
      <div class="circle_one flex-box">
        <img :src="item.img" />
      </div>
      <div>
        <span>{{ item.name }}</span>
        <div class="valueNum" :style="{ color: item.color }">
          <span class="num">{{ item.value }}</span>
          <span class="ys">({{ item.unit }})</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findIndexByName } from "@/util/index";
import { get } from "@/api/index";
export default {
  data() {
    return {
      navList: [],
      list: [],
      xzIndex: 0,
      listBat: [
        {
          name: "规模养殖企业",
          img: require("images/granary/nav/jqcz.png"),
          value: 0,
          color: "#E7F802",
          unit: "家"
        },
        {
          name: "年生猪出栏量",
          img: require("images/granary/nav/szcz.png"),
          value: 521.8471,
          color: "#00FFFF",
          unit: "万头"
        },

        {
          name: "年肉类产品产量",
          img: require("images/granary/nav/rlzcl.png"),
          value: 70.1442,
          color: "#00AEFF",
          unit: "万吨"
        },
        {
          name: "年饲料产量",
          img: require("images/granary/nav/jqcz.png"),
          value: 220.1054,
          color: "#E7F802",
          unit: "万吨"
        },
        {
          name: "总产值",
          img: require("images/granary/nav/zcz.png"),
          value: 286.23,
          color: "#FF9000",
          unit: "亿元"
        }
      ]
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      get("/api/dp/visual/queryList?code=xm_headdata").then(res => {
        if (!res.data.length > 0) {
          return;
        }
        const data = res.data[0];
        const item = res.item;
        this.listBat.forEach((e, i) => {
          const index = findIndexByName(e.name, item, "name");
          if (index > -1) {
            this.listBat[i]["value"] = data[item[index]["code"]];
            this.listBat[i]["unit"] = item[index]["unit"];
          }
        });
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.navBar
  background-color rgba(1,22,76 , 0.7)
  border-radius 4px
  position absolute
  color #fff
  right calc(27% - 10px)
  left calc(27% - 10px)
  z-index 1
  top 105px
  justify-content space-around
  font-size .06rem
  height .35rem

.cube
//   background url('~images/index/nav/navBg.png') center no-repeat
//   background-size 100% 100%
//   opacity .9
//   width 18%
  height 100%
  justify-content center

.valueNum
  color $textColor
.xzBar
  background rgba(11,46,42,0.8)
  box-shadow inset 0px 0px 0.06rem #0ff
.num
  font-size .15rem

.circle_one
  position relative
  margin-right .05rem
  width 40px
  height 40px
//   background url('~images/granary/nav/nav-bg.png') no-repeat center
//   background-size 100% 100%

  img
    width 30px
    height 30px
    // vertical-align middle
</style>
